import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';

export const VariableBlobNodeView: React.FC<NodeViewProps> = ({ node }) => {
  return (
    <NodeViewWrapper
      as="span"
      className="variable-blob-node"
      draggable="true"
      data-drag-handle=""
    >
      <span className="variable-blob-content">
        {node.attrs.name}
      </span>
    </NodeViewWrapper>
  );
};
